export const BLUE_BG_COLOR = "rgba(9, 97, 127, 1)";
export const WHITE_BG_COLOR = "rgba(255, 255, 255, 1)";
export const GREY_BG_COLOR = "rgba(104, 104, 109, 1)";
export const LIGHT_GREY_BG_COLOR = "rgba(209, 218, 209, 1)";

export const BLACK_TEXT_COLOR = "rgba(0, 0, 0, 1)";
export const WHITE_TEXT_COLOR = "rgba(255, 255, 255, 1)";
export const GREY_TEXT_COLOR = "rgba(87, 87, 95, 1)";
